import React from "react";

const ConnectUs = () => {
  return (
    <div className="container-fluid">
      <div className="row text-center padding">
        <div className="col-12">
          <h2>Connect</h2>
        </div>
        <div className="col-12 social">
          <a href="https://www.facebook.com/Visualization-of-Algorithm-VA-111466056956715/?ref=profile_intro_card">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://myaccount.google.com/">
            <i className="fa fa-envelope"></i>
          </a>
          <a href="https://github.com/minhairtran">
            <i className="	fa fa-gitlab"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ConnectUs;
